import Reactotron, { trackGlobalErrors } from 'reactotron-react-js'

if (process.env.NODE_ENV !== 'production') {
  Reactotron
    .configure() // we can use plugins here -- more on this later
    // window.onerror 를 추적한다
    .use(trackGlobalErrors({
      offline: true
    })) // <--- here we go!
    // .use(openInEditor()) // <--- here we go!
    .connect() // let's connect!
  // -----------------------------------------------------------------------------------------------------------

  console.tron = Reactotron
  console.tron.log('Reactotorn 연결됨')
}

// console.tron.logImportant('I am important')

// console.tron.log({ numbers: [1, 2, 3], boolean: false, nested: { here: 'we go' } })
// console.tron.warn('*glares*')
// console.tron.error('Now you\'ve done it.')
// console.tron.display({
//   name: 'KNOCK KNOCK',
//   preview: 'Who\'s there?',
//   value: 'Orange.'
// })
//
// console.tron.display({
//   name: 'ORANGE',
//   preview: 'Who?',
//   value: 'Orange you glad you don\'t know me in real life?',
//   important: true
// })

// Custom Commands
// Need a custom Reactotron plugin but don't have time to write one?
//
// In the Reactotron App, you can press command+. (mac) or ctrl+. (windows/linux) to send a custom command.
//
//   These commands can be using for things like:
//
//   clearing async storage
// triggering an api call
// calling functions on hard-to-reach places
// sending info back to reactotron app
// Writing your own Reactotron middleware makes this happen. Check out this example:
//
//   import Reactotron from 'reactotron-react-native'
//
// Reactotron.use(tron => ({
//   onCommand({ type, payload }) {
//     if (type === 'custom') {
//       tron.display({ name: 'ECHO', preview: payload })
//     }
//   },
// }))

// Benchmarking
// If you have a function you believe is slow, you can benchmark it to find any bottlenecks like this:
//
// function slowFunction() {
//   const bench = Reactotron.benchmark("slow function benchmark")
//
//   // Code that does thing A
//   bench.step("Thing A")
//
//   // Code that does thing B
//   bench.step("Thing B")
//
//   // Code that does thing C
//   bench.stop("Thing C")
// }
// Note that the last call is to stop instead of step! This is important because otherwise the benchmark results won't display in Reactotron.
